export interface IGDOObject {
  deviceId: string;
  deviceName: string;
  homeId: string;
  homeName: string;
  serialNumber: string;
  activationState: boolean;
  deviceStatus: string;
  activationDate: number;
  modelNumber: string;
  vacationMode: boolean;
  ledStatus: number;
  deviceConnectionStatus: number;
  enableWifi: boolean;
  percentage: number;
  inProgress: number;
  sSIDWifi: string;
  cycles: number;
  brand: string;
  connectedAC: number;
  batteryVoltage: string;
  deleted: boolean;
  firmwareUpdateStatus: string;
  fwForceUpdate: boolean;
  firmwareVersion: string;
  manualMatterCode: string;
  activationdate: number;
  lastUpdateStatus: number;
  alignSensor: string;
  alarmMI: string;
  alarmOD: string;
  alarmOE: string;
  alarmOG: string;
  alarmOF: string;
  closeAttemptCounter?: string;
  productFamily?: string;
  manufacturedDate?: string;
  sku?: string;
  lcuSerialNumber?: string;
  lcuFirmware?: string;
  lcuHardwareRevision?: string;
  lcuModel?: string;
  lcuFwStatus?: string;
  lcuFwForceUpdate?: boolean;
  rcbHardwareRevision?: string;
  rcbModel?: string;
}

export interface IGDOHistory{
  id: string;
  deviceId: string;
  deviceName: string;
  recordId: number;
  recordStatus: number;
  user: string;
  eventGroupId: number;
  eventBy: string;
  operationEvent: number;
  garageState: string;
  garagePercentage: number;
  batteryVoltage: number;
  dcVoltage: number;
  timeStamp: number;
  createdTime: number;
  timeZone: string;
  timeZoneInSeconds: number;
  ssidWifi: string;

  eventName: string;
  date: string;
  time: string;
  eventDes: string;
  eventIcon: string;
  eventColor: string;
}

export interface ListHistory {
  month: string;
  history: IGDOHistory[];
}

export interface SearchRequest {
  lockName: string;
  filterActivity: string;
  filterUserType: string;
  orderBy: string
  sortBy: string;
  startKey: number;
  top: number;

  fromDate: string;
  toDate: string;
  gdoFilterActivity: GdoFilterActivity[];
  gdoFilterUserType: string;
  gdoDeviceName: string;
}

export interface GdoFilterActivity {
  groupId?: string;
  eventId?: string;
  eventBy?: string;
}


export enum GdoEventBy {
  UNKNOWN = 0,

  BLE_SC= 1,

  WIFI= 2,

  AUTO_CLOSE_TIME = 3,

  AUTO_CLOSE_DELAY = 4,

  REMOTE = 5,

  KEYPAD = 6,

  WALL_STATION = 7,

  MANUAL = 8,

  MATTER = 9,

  OZONE_TEST = 10,

  LCU_ALIGNED_SENSOR = '13',

  LCU_OBSTACLE = '14'
}

export enum GdoEventGroup {
  SYSTEM = 0,

  GDO_OPERATION = 1,

  AUTO_OPERATION = 2,

  WIFI_MANAGEMENT = 3,

  VACATION_MODE = 4,

  BATTERY = 5,

  SENSOR = 6,

  GDO_MANAGEMENT = 7,

  ALARM = 8,

  ALARM2 = 9,

  DELETE_ACTIVITY = 10,

  ADD_NEW_DEVICE= 208
}

export enum GdoVacationMode {
  OFF = 0,
  ON = 1
}

export enum EventGdoStatus {
  CLOSED = 1,
  OPEN = 3,
  INTERIM_POS = 5,
  CLOSING = 7,
  OPENING = 8,
  PARTIAL = 9,
  AUTO = 0
}

export enum EventAutoGdoStatus {
  CLOSED = "1",
  OPEN = "3",
  INTERIM_POS = "5",
  CLOSING = "7",
  OPENING = "8",
  PARTIAL = "9"
}

export enum GdoWifiStatus {
  DISCONNECTED = 0,
  CONNECTED = 1,
}

export enum GdoBatteryStatus {
  BATTERY_FLAT = 0,
  BATTERY_LOW = 1,
  POWER_PLUGIN = 5
}

export enum GdoNewDevice {
  LOG_NEW_DEVICE = 9
}

export enum GdoStatus {
  CLOSED = '01',
  OPEN = "03",
  INTERIM_POS = "05",
  CLOSING = "07",
  OPENING = "08",
  PARTIAL = "09"
}

